<template>
  <section class="works">
    <title-bg></title-bg>
    <div class="works-area">
      <div class="works-filter">
        <span class="works-filter-icon"></span>
        <a-input placeholder="请输入要搜索的内容" v-model="defaultValue" @keyup.enter.native="search"></a-input>
        <a-button type="primary" class="works-filter-button" @click="search">确定</a-button>
      </div>
      <a-button type="primary" @click="bindUploadBtn">
        <img src="../../../assets/image/add-icon.png" alt="" class="add-icon">作品上传
      </a-button>
    </div>
    <a-spin :spinning="loading" tip="Loading..." :delay="500" style="min-height: 70px;">
      <ul class="works-list" v-if="Object.keys(dataList).length > 0">
        <grand-works-item v-for="(item, index) in dataList" :key="index" :grandInfo="item"></grand-works-item>
      </ul>
      <a-empty v-else description="暂无数据" style="margin-top:20px;"/>
    </a-spin>
    <pagination :currentPage="currentPage" :total="total" :limitPage="limitPage" :pageType="'grandworks'"></pagination>
  </section>
</template>
<script>
import TitleBg from '../../../components/TitileBg'
import GrandWorksItem from '../../../components/GrandWorksItem'
import Pagination from '../../../components/Pagination'
import { GrandWorks } from '../../../common/garden/GrandWorks'
export default {
  mixins: [GrandWorks,],
  components: {
    TitleBg,
    GrandWorksItem,
    Pagination
  },
}
</script>
<style lang="less" scoped>
.works{
  flex-grow: 1;
  overflow: hidden;
  &-area{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 43px 0 23px;
    height: 38px;
    & /deep/ .ant-btn{
      display: flex;
      align-items: center;
      width:116px;
      height:38px;
      border-radius:4px;
      .add-icon{
        margin-right: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }
  &-filter{
    display: flex;
    align-items: center;
    height: 38px;
    width: 463px;
    background: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 4px;
    overflow: hidden;
    &-icon{
      border-right: 1px solid #D1D1D1;
      width: 57px;
      height: 38px;
      background: url('../../../assets/image/search-icon.png') no-repeat center center;
      background-size: 19px 15px;
    }
    & /deep/ .ant-input{
      height: 38px;
      line-height: 38px;
      border: none;
    }
    &-button{
      height: 100%;
      width: 77px;
      background: #C16613;
      border:none;
      border-radius: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  &-list{
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    padding-bottom: 15px;
    margin-right: -15px
  }
}
</style>
